import { render, staticRenderFns } from "./register-btn.vue?vue&type=template&id=6fad0cca&scoped=true&"
import script from "./register-btn.vue?vue&type=script&lang=js&"
export * from "./register-btn.vue?vue&type=script&lang=js&"
import style0 from "./register-btn.vue?vue&type=style&index=0&id=6fad0cca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fad0cca",
  null
  
)

export default component.exports